module.exports = __webpack_public_path__ + "static/media/TW-father-joe-desktop-1220x150@2x.1540c220.jpg";